import React from 'react';
import { IconProps } from './types';

export const MarketOverviewIcon = (props: IconProps) => {
  const { size = 24, color = 'currentColor', style = {} } = props;

  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.19951 7.17267H7.22631C8.33614 7.17267 9.24418 8.07267 9.24418 9.17267V12.1727C9.24418 13.2727 8.33614 14.1727 7.22631 14.1727H4.19951C3.08968 14.1727 2.18164 13.2727 2.18164 12.1727V9.17267C2.18164 8.07267 3.08968 7.17267 4.19951 7.17267Z'
        stroke='#DFF60D'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.71289 14.1726V17.1726'
        stroke='#DFF60D'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.1087 5.08182H18.1355C19.2453 5.08182 20.1534 5.98182 20.1534 7.08182V17.0818C20.1534 18.1818 19.2453 19.0818 18.1355 19.0818H15.1087C13.9989 19.0818 13.0908 18.1818 13.0908 17.0818V7.08182C13.0908 5.98182 13.9989 5.08182 15.1087 5.08182Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.6221 19.0818V22.0818'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.6221 2.18182V4.18182'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
